import { useFormContext } from "react-hook-form";
import { IExlySearchableDropdownOption } from "repoV2/features/Common/modules/Form/modules/ExlySearchableDropdown/ExlySearchableDropdown.interfaces";
import useSetFormData from "repoV2/features/Common/modules/FormData/utils/useSetFormData";
import { FORM_KEYS } from "repoV2/features/Common/modules/FormData/FormData.constants";
import { checkIsStringEmpty } from "repoV2/utils/common/dataTypes/string";
import { delivery_details_form_constant } from "./DeliveryDetailsFormGroup.contants";

const {
    basic_details: {
        form_fields: {
            delivery_address,
            delivery_pin_code,
            delivery_state,
            delivery_city,
        },
    },
} = delivery_details_form_constant;

export const useDeliveryDetailsFormGroup = () => {
    const { getValues } = useFormContext();
    const { setFormData } = useSetFormData();

    const deliveryStateValidator = () => {
        const data = getValues() || {};
        const option: IExlySearchableDropdownOption =
            data[delivery_state.field_name];
        return checkIsStringEmpty(option?.value) ? "Required" : true;
    };

    const setDeliveryDetailsFormData = ({
        fieldName,
        value,
    }: {
        fieldName: string;
        value?: IExlySearchableDropdownOption;
    }) => {
        const data = getValues() || {};
        setFormData(
            `${FORM_KEYS.delivery_details}.${fieldName}`,
            value || data[fieldName]
        );
    };

    const addressFieldConfig = {
        name: delivery_address.field_name,
        placeholder: delivery_address.placeholder,
        validate: (value: string) => {
            const _value = value.trim() || "";
            return checkIsStringEmpty(_value) ? "Required" : true;
        },
        blur: () => {
            setDeliveryDetailsFormData({
                fieldName: delivery_address.field_name,
            });
        },
    };

    const cityFieldConfig = {
        name: delivery_city.field_name,
        placeholder: delivery_city.placeholder,
        validate: (value: string) => {
            const _value = value.trim();
            return checkIsStringEmpty(_value) ? "Required" : true;
        },
        blur: () => {
            setDeliveryDetailsFormData({
                fieldName: delivery_city.field_name,
            });
        },
    };

    const pinCodeFieldConfig = {
        name: delivery_pin_code.field_name,
        placeholder: delivery_pin_code.placeholder,
        validate: (value: string) => {
            const _value = value.trim() || "";
            return checkIsStringEmpty(_value) ? "Required" : true;
        },
        blur: () => {
            setDeliveryDetailsFormData({
                fieldName: delivery_pin_code.field_name,
            });
        },
    };

    const stateFieldConfig = {
        name: delivery_state.field_name,
        placeholder: delivery_state.placeholder,
        validate: deliveryStateValidator,
        change: (value: IExlySearchableDropdownOption) => {
            setDeliveryDetailsFormData({
                fieldName: delivery_state.field_name,
                value,
            });
        },
    };

    return {
        setDeliveryDetailsFormData,
        deliveryStateValidator,
        addressFieldConfig,
        cityFieldConfig,
        pinCodeFieldConfig,
        stateFieldConfig,
    };
};
